export const EDIT_PROFILE = "EDIT_PROFILE"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
export const PROFILE_ERROR = "PROFILE_ERROR"
export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG";


export const GET_PROFILE_DETAIL = "GET_PROFILE_DETAIL"
export const GET_PROFILE_DETAIL_SUCCESS = "GET_PROFILE_DETAIL_SUCCESS"
export const GET_PROFILE_DETAIL_FAILED = "GET_PROFILE_DETAIL_FAILED"